<template>
  <div>
    <div class="page-content">
      <div class="container-fluid background">
        <div class="row">
          <img src="~@/assets/images/brick-wall.jpg" alt="Brick wall" class="col-12 p-0">
        </div>
      </div>
      <div class="container content">
        <div class="row">
          <div class="col-12">
            <h1 class="page-header">
              Testimonials
              <hr />
            </h1>
          </div>
        </div>

        <div class="row">
              <div class="mb-4 col-sm-6 col-lg-4">
                <div class="card">
                  <div class="card-body">
                    <p class="card-subtitle mb-2"><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i></p>
                    <p class="card-text">
                      Liam from Ashfield Brickwork has been bricklaying for us for several years and on various jobs , he is very professional and a very accomplished bricklayer, we have always been really impressed with his work <b> - Sandra</b>
                    </p>
                  </div>
                </div>
              </div>

              <div class="mb-4 col-sm-6 col-lg-4">
                <div class="card">
                  <div class="card-body">
                    <p class="card-subtitle mb-2"><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i></p>
                    <p class="card-text">
                      Very neat brickwork, very pleased with the job done. <b> - Graham Orford</b>
                    </p>
                  </div>
                </div>
              </div>

              <div class="mb-4 col-sm-6 col-lg-4">
                <div class="card">
                  <div class="card-body">
                    <p class="card-subtitle mb-2"><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i></p>
                    <p class="card-text">
                      Highly recommend Liam.  First class work.  He came to our house to complete an extension and many other interior and exterior jobs for us.   His workmanship was first class, nothing too much trouble for him and was great to have around the house as he is such a friendly guy.  Highly recommend Liam. <b> - Tanya Chenery</b>
                    </p>
                  </div>
                </div>
              </div>

              <div class="mb-4 col-sm-6 col-lg-4">
                <div class="card">
                  <div class="card-body">
                    <p class="card-subtitle mb-2"><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i></p>
                    <p class="card-text">
                      I used Liam to extend my patio, and I couldn't be happier with the results. From start to finish, Liam was professional and punctual. He listened carefully to what I wanted, offered helpful suggestions, and executed everything with great attention to detail.
                      <br>
                      The quality of the patio is top-notch—clean lines, level surface, and a seamless match to the existing patio. He left the site spotless at the end of each day and completed the project on time, exactly as promised.
                      <br>
                      Liam takes pride in his work, and it really shows. I wouldn't hesitate to recommend them to anyone looking for bricklaying or patio work. <b> - Kieran</b>
                    </p>
                  </div>
                </div>
              </div>

              <div class="mb-4 col-sm-6 col-lg-4">
                <div class="card">
                  <div class="card-body">
                    <p class="card-subtitle mb-2"><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i></p>
                    <p class="card-text">
                      Liam is a fastidious hard worker. He made a beautiful job of bricking our old well made even better than we expected. He worked over a whole weekend in inclement weather. He obviously takes a great deal of pride in his work. I would more than highly recommend his work a true craftsman and a pleasure to deal with. <b> - Mark Cairey</b>
                    </p>
                  </div>
                </div>
              </div>

              <div class="mb-4 col-sm-6 col-lg-4">
                <div class="card">
                  <div class="card-body">
                    <p class="card-subtitle mb-2"><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i></p>
                    <p class="card-text">
                      Liam and his team did a fantastic job on completing my dream porch.
                      <br>
                      Their time keeping was spot on, they were very polite and really good with the kids and dog. The workmanship and attention to detail was very high. I couldn't recommend them enough. <b> - Charlene Calladine</b>
                    </p>
                  </div>
                </div>
              </div>

          </div>
       </div>
    </div>
    <div id="cta-banner" class="cta-banner">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-xl-3 cta-banner-wrapper">
            <h2 class="cta-banner-title">
              Get In Touch
            </h2>
          </div>
          <div class="col-lg-8 col-xl-6 cta-banner-wrapper">
            <p class="cta-banner-content">
              For your free no obligation quote, get in touch today
            </p>
          </div>
          <div class="col-lg-4 col-xl-3 cta-banner-wrapper">
            <router-link to="/contact-us/" class="mt-4 mt-lg-0 btn cta-banner-btn">
              Contact Us
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'testimonials'
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/variables/colors";
@import "../../assets/styles/variables/breakpoints";

/****************************
    BANNER
*****************************/
.background {
  margin-top: -64px;
  width: 100%;
  height: 430px;
  border-bottom: 3px solid $primary;

  @media screen and (max-width: $md-breakpoint) {
    height:  300px;
  }

  .row {
    height: 100%;
  }
  .row img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

/****************************
    CONTENT
*****************************/
.content {
  margin-top: 64px;
}

/****************************
    GET IN TOUCH CTA
*****************************/
.cta-banner {
  background-color: $primary;
  padding: 30px 0;

  &-wrapper {
    display: flex;
    align-items: center;

    &:last-child {
      justify-content: flex-end;

      @media (max-width: $lg-breakpoint) {
        justify-content: center;
      }

      @media (max-width: $md-breakpoint) {
        justify-content: flex-start;
      }
    }
  }

  &-title {
    font-size: 40px;
    font-weight: 500;
    color: $white;
  }

  &-content {
    margin: 0;
    font-size: 18px;
    color: $white;
  }

  &-btn {
    background-color: $primary-dark;
    &:hover {
      background-color: $white;
      color: $primary;
    }
  }
}

/****************************
    Testimonials
*****************************/

.card {
  height: 100%;

  border: 0;
  background-color: #f5f5f5;
  box-shadow: $shadow;


  &-body {
    border-right: 20px solid $primary-dark;
  }

  &-title {
    color: $primary-dark;
    font-weight: 700;
  }

  &-subtitle {
    font-size: 18px;
  }

  &-text {
    font-weight: 400;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Testimonies.vue